import styled from '@emotion/styled'
import tw from 'twin.macro'
import { Button, FlyingBag } from '@pretamanger/component-library'

export const OrderAgainButton = styled(Button)``

export const LastOrderIcon = styled(FlyingBag)`
  ${tw`inline-block align-baseline mr-2`}
`

export const LastOrderWrapper = styled.div`
  ${tw`px-4 md:px-6 pb-6 pt-4 mb-10 bg-grey-50 -mx-4 md:mx-0`}
`
export const Heading = styled.h2`
  ${tw`mb-5`}
`

export const HeadingContentWrapper = styled.div`
  ${tw`flex items-center font-bold text-xl`}
`

export const LastOrderCardWrapper = styled.div`
  ${tw`grid grid-cols-1 md:grid-cols-2`}
`

export const LastOrderCard = styled.div`
  box-shadow: 0 0 24px rgba(0, 0, 0, 0.12);
  ${tw`bg-white rounded p-5 flex justify-between items-center`}
`
export const LastOrderColumnRight = styled.div``
export const LastOrderColumnLeft = styled.div`
  p.other-products {
    ${tw`mt-1 text-gray-600 text-sm`}
  }
`
export const LastOrderLabel = styled.span`
  ${tw`font-normal mb-2 text-xl`}
`
